<header class="relative py-8 lg:py-28" id="bg-course-search-clearing">
	<div class="container">
		<div class="justify-between gap-6">
			<div class="w-full max-w-prose">
				<div class="z-10 text-white">
					<div class="flex">
						<uc-statements-bookmark-svg />
						<h1 class="mb-3 font-semibold capitalize">
							{{ formattedSubject() }} Clearing Courses
						</h1>
					</div>

					<h2 class="mb-3 text-3xl font-extrabold">{{ subtitle() }}</h2>
					<p class="text-base">
						{{ description() }}
					</p>
				</div>
				<div class="flex flex-col gap-4 sm:items-center sm:flex-row mt-9">
					<a
						class="h-full px-5 text-sm font-bold !py-2.5 text-center blue-button flex items-center justify-center sm:justify-start focus:outline-none"
						[routerLink]="['/courses', 'degrees', 'undergraduate', subject()]"
					>
						<uc-search-svg customStyles="mr-3 !w-6 !h-6" />
						Search Undergraduate Courses </a
					><a
						[routerLink]="['/universities', 'undergraduate']"
						class="flex items-center h-full px-5 !py-2.5 text-sm font-bold white-header-btn justify-center sm:justify-start focus:outline-none"
					>
						<uc-search-svg customStyles="mr-3 !w-6 !h-6" />
						Search Universities
					</a>
				</div>
			</div>
		</div>
	</div>
</header>
